var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.resetPwd)?_c('div',[_c('ResetPwd',{attrs:{"pwdResetToken":_vm.resetPwdToken}})],1):(_vm.isAuthenticated)?_c('div',[_c('keep-alive',[_c('Main')],1)],1):_c('div',[_c('Login')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }